<template>
  <div class="bg-white dark:bg-neutral-800 pb-4 rounded-md min-w-0 shadow">
    <TheNuxtLink :to="href" class="flex flex-col h-full">
      <AsyncImage
        :src="banner"
        class="object-cover rounded-t-md w-full aspect-[7/2]"
      />
      <div
        class="flex-grow -mt-12 px-4 w-full flex flex-col items-center justify-between"
      >
        <div>
          <AsyncImage
            :src="avatar"
            class="rounded-md mx-auto w-20 h-20 border-2 border-black dark:border-white"
          />
          <div class="flex w-full items-center justify-center mt-1">
            <BadgeUsername class="font-medium xl:text-lg 2xl:text-xl" :verified>
              {{ displayName }}
            </BadgeUsername>
          </div>
          <p
            class="mb-1 text-sm text-center text-neutral-600 dark:text-neutral-400"
          >
            Organization
          </p>
        </div>
        <NamiButton
          :small="sm"
          block
          :buttonType="following ? 'secondary' : 'primary'"
          @click.stop.prevent="toggleOrgFollow"
          :disabled="disableFollow || initialFollowPending"
        >
          {{ following ? "Unfollow" : "Follow" }}
        </NamiButton>
      </div>
    </TheNuxtLink>
  </div>
</template>

<script setup lang="ts">
import type {
  OrganizationEntity,
  OrganizationRelation,
  PopulateRelationship,
} from "~/src/api";
import { parseOrgForDisplay } from "~/utils/display/org";

const props = defineProps<{
  org: OrganizationEntity | PopulateRelationship<OrganizationRelation>;
  following: boolean;
  disableFollow?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:following", v: boolean): void;
}>();

const nuxtApp = useNuxtApp();
const auth = nuxtApp.$auth();
const app = nuxtApp.$app();
const { sm } = useBreakpoints();

const computedOrg = computed(() => props.org);

const { href, banner, avatar, displayName, verified } =
  parseOrgForDisplay(computedOrg);

const { isFollowing, toggleFollow, initialFollowPending } = useFollow(
  "organization",
  computed(() => props.org.id),
);

const toggleOrgFollow = () => {
  emit("update:following", !isFollowing.value);
  toggleFollow();
};
</script>
